import React from 'react'
import Select from 'react-select'
import {FormGroup, Label, Input} from 'reactstrap'

export default class SelectLocation extends React.Component {

    constructor(props) {
        super(props)
        const end_location = this.props.end_location || localStorage.getItem('end_location')
        this.state = {
            pickLocations: this.filterPickLocations(this.props.locations),
            dropLocations: this.filterDropLocations(this.props.locations),
            pickLocation: {value: this.props.start_location || localStorage.getItem('start_location') || 2},
            dropLocation: {value: end_location},
            dropVisible: !!end_location || this.props.edit,
            pickError: false
        }
    }

    filterPickLocations = () => {
        if(this.props.valid_pick_ups && this.props.valid_pick_ups.length > 0) {
            return this.props.locations.filter(l => this.props.valid_pick_ups.includes(l.value))
        }
        return this.props.locations
    }

    filterDropLocations = () => {
        if(this.props.valid_drop_offs && this.props.valid_drop_offs.length > 0) {
            return this.props.locations.filter(l => this.props.valid_drop_offs.includes(l.value))
        }
        return this.props.locations
    }

    renderPick = () => {
        const {pickLocation} = this.state
        const placeholder = <span><i className={'fa fa-map-marker mr-2'}/> {this.props.t.pick_empty}</span>
        return (
            <div>
                {!this.state.pickError &&
                <div className={'small'}>{this.props.t.pick_label}</div>
                }
                {this.state.pickError &&
                <div className={'small hasError'}>{this.props.t.search.error_pick_l}{' '}{this.props.t.e_required}</div>
                }
                <Select
                    name={'pick_location_id'}
                    placeholder={placeholder}
                    value={pickLocation && pickLocation.value}
                    onChange={(pickLocation) => {
                        this.setState({pickLocation: pickLocation, pickError: false})
                        localStorage.setItem('start_location', pickLocation && pickLocation.value)
                    }}
                    options={this.state.pickLocations}
                    style={this.state.pickError ? {'border': '1px solid red', 'background': '#fff6f6'} : {}}
                />
            </div>
        )
    }

    renderDrop = () => {
        const {dropVisible, dropLocation} = this.state
        const placeholder = <span><i className={'fa fa-map-marker mr-2'}/> {this.props.t.return_empty}</span>
        if (dropVisible)
            return (
                <div className={'mt-2'}>
                    {!this.state.dropError &&
                    <div className={'small'}>{this.props.t.return_label}</div>
                    }
                    {this.state.dropError &&
                    <div
                        className={'small hasError'}>{this.props.t.return_label}{' '}{this.props.t.e_required}</div>
                    }
                    <Select
                        name={'drop_location_id'}
                        placeholder={placeholder}
                        value={dropLocation && dropLocation.value}
                        onChange={(dropLocation) => {
                            this.setState({dropLocation: dropLocation, dropError: false})
                            localStorage.setItem('end_location', dropLocation && dropLocation.value)
                        }}
                        options={this.state.dropLocations}
                        style={this.state.dropError ? {'border': '1px solid red', 'background': '#fff6f6'} : {}}
                    />
                </div>
            )
    }

    render() {
        return (
            <div className={'pt-2 mb-3'}>
                {this.renderPick()}
                {!this.props.edit &&
                <FormGroup check>
                    <Label check className={'mt-2'}>
                        <Input type="checkbox"
                               checked={this.state.dropVisible || false}
                               onChange={() => {
                                   if (this.state.dropVisible)
                                       localStorage.removeItem('end_location')
                                   this.setState({dropVisible: !this.state.dropVisible})
                               }}
                        />{' '}
                        {this.props.t.return_check}
                    </Label>
                </FormGroup>
                }
                {this.renderDrop()}
            </div>
        )
    }


}